export const background = Object.freeze({
  hit: 'hit',
  idle: 'idle'
})

export const villain = Object.freeze({
  hit: 'hit',
  idle: 'idle'
})

export const globalData = {
  maxnum: 100,
  counter: 0,
  numInRow: 10,
  bingoNum: 1,
  bingoNumArr: [],
}

export const SETTLEMENT_TYPE = {
  LIVE_DRAW: 'LIVE-DRAW',
  RANDOM_NUMBER_GENERATOR_DRAW: 'RANDOM-NUMBER-GENERATOR-DRAW',
  MANUAL_NUMBER_DRAW: 'MANUAL-NUMBER-DRAW',
}